import { render } from "./BrandLogos.vue?vue&type=template&id=6a8eef38&scoped=true"
import script from "./BrandLogos.vue?vue&type=script&lang=js"
export * from "./BrandLogos.vue?vue&type=script&lang=js"

import "./BrandLogos.vue?vue&type=style&index=0&id=6a8eef38&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8eef38"]])

export default __exports__